// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { accordionClasses } from '@mui/material/Accordion';
import { accordionSummaryClasses } from '@mui/material/AccordionSummary';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { rem } from '../../tokens/conversions';
import { accordionColors } from './accordionColors';
export var Accordion = function(mode) {
    var c = accordionColors(mode);
    var _obj, _obj1, _obj2, _obj3;
    var override = {
        MuiAccordion: {
            styleOverrides: {
                root: (_obj = {
                    boxShadow: 'none',
                    backgroundColor: c.default.background,
                    borderBottom: "".concat(rem(1), " solid ").concat(c.border),
                    '&:before': {
                        display: 'none'
                    }
                }, _define_property(_obj, "&.".concat(accordionClasses.expanded), {
                    margin: 0
                }), _define_property(_obj, "&.".concat(accordionClasses.disabled), {
                    color: c.disabled.title,
                    backgroundColor: c.disabled.background,
                    opacity: 1,
                    '& .MuiAccordionDetails-root': {
                        color: c.disabled.text
                    }
                }), _define_property(_obj, '&:first-of-type', {
                    borderRadius: rem(0)
                }), _define_property(_obj, '&:last-of-type', {
                    borderRadius: rem(0)
                }), _obj)
            },
            variants: [
                {
                    props: {
                        condensed: true
                    },
                    style: (_obj1 = {}, _define_property(_obj1, "& .".concat(accordionSummaryClasses.root), {
                        padding: rem(8),
                        fontSize: rem(14),
                        lineHeight: rem(18)
                    }), _define_property(_obj1, "& .".concat(accordionSummaryClasses.expandIconWrapper, " .").concat(svgIconClasses.root), {
                        fontSize: rem(16)
                    }), _obj1)
                },
                {
                    props: {
                        disableBottomBorder: true
                    },
                    style: {
                        borderBottom: 'none'
                    }
                }
            ]
        },
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    padding: rem(16),
                    display: 'flex',
                    flexDirection: 'column',
                    gap: rem(10),
                    color: c.detailsText
                }
            }
        },
        MuiAccordionSummary: {
            styleOverrides: {
                root: (_obj2 = {
                    padding: rem(16),
                    color: c.title,
                    '&:hover': {
                        backgroundColor: c.hover.background
                    },
                    '&:active': {
                        backgroundColor: c.active.background
                    },
                    '&.Mui-focusVisible': {
                        outline: "".concat(rem(2), " solid ").concat(c.focus.border),
                        outlineOffset: rem(-2)
                    }
                }, _define_property(_obj2, "&.".concat(accordionSummaryClasses.expanded), {
                    borderBottom: 'none'
                }), _define_property(_obj2, "&.".concat(accordionSummaryClasses.disabled), _define_property({
                    opacity: 1,
                    color: c.disabled.title
                }, "& .".concat(accordionSummaryClasses.expandIconWrapper), {
                    color: c.disabled.title
                })), _obj2),
                content: _define_property({
                    margin: 0
                }, "&.".concat(accordionSummaryClasses.expanded), {
                    margin: 0
                })
            },
            variants: [
                {
                    props: {
                        iconPosition: 'left'
                    },
                    style: (_obj3 = {
                        flexDirection: 'row-reverse',
                        gap: rem(8)
                    }, _define_property(_obj3, "& .".concat(accordionSummaryClasses.expandIconWrapper), {
                        transform: 'rotate(-90deg)'
                    }), _define_property(_obj3, "& .".concat(accordionSummaryClasses.expandIconWrapper, ".").concat(accordionSummaryClasses.expanded), {
                        transform: 'rotate(0deg)'
                    }), _obj3)
                }
            ]
        }
    };
    return override;
};

//# sourceMappingURL=Accordion.js.map